<template>
  <warranty-film-type-list v-bind="$props" />
</template>

<script>
import WarrantyFilmTypeList from '@/components/WarrantyFilmTypeList';

export default {
  name: 'ExtendedWarrantyTab',

  components: {
    WarrantyFilmTypeList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
